import React, { useCallback } from "react";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import styles from "../styles";
import { useTranslation } from "react-i18next";
import { CheckCircle, HighlightOffOutlined } from "@material-ui/icons";
import { useApolloClient } from "@apollo/client";
import { HELPBUTTON_POPOVER_OPEN_QUERY } from "features/helpButton/queries";
import cx from "classnames";

const useStyles = makeStyles(styles);

function CustomDivider(classes) {
  return (
    <div className={classes.divider}>
      <div className={classes.innerShadow}></div>
      <div className={classes.arrowDown}>
        <div className={classes.arrowDownShadow}></div>
      </div>
    </div>
  );
}

function QuoteWithFinalStatus(isFinalized, classes, t) {
  return (
    <Grid item container xs={12} spacing={2} alignItems="center" className={classes.paddingRightLeft10}>
      <Grid item xs={12}>
        <Typography variant="subtitle1" component="div" className={classes.fontWeightBold}>
          {t("DocumentsReceivedConfirmation.Confirmation")}
        </Typography>
        <Typography variant="caption" component="div">
          {t("DocumentsReceivedConfirmation.ThankYouForSubmitting")}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        container
        className={isFinalized ? classes.confirmationItem : classes.contractInfoBorder}
        style={{ margin: "10px 0" }}
      >
        <Grid item xs={1} container alignItems="center" justifyContent="center">
          <CheckCircle className={classes.fontSize35} />
        </Grid>
        <Grid item xs={11}>
          <Typography variant="subtitle2" component="div" className={classes.fontWeightBold}>
            {t("DocumentsReceivedConfirmation.SignedContractualDocumentsReceived")}
          </Typography>
          <Typography variant="body2" component="div">
            {t("DocumentsReceivedConfirmation.SignedDocumentReceived")}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.gridItemPadding}>
        {CustomDivider(classes)}
      </Grid>
      <Grid
        item
        xs={12}
        container
        className={isFinalized ? classes.confirmationItem : classes.contractInfoBorder}
        style={{ margin: "10px 0" }}
      >
        <Grid item xs={1} container alignItems="center" justifyContent="center">
          <CheckCircle className={classes.fontSize35} />
        </Grid>
        <Grid item xs={11}>
          <Typography variant="subtitle2" component="div" className={classes.fontWeightBold}>
            {t("DocumentsReceivedConfirmation.SignedContractualDocumentAccepted")}
          </Typography>
          <Typography variant="body2" component="div">
            {t("DocumentsReceivedConfirmation.SignedContractualDocumentsReviewedAndAccepted")}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

function ContractStatusContainer(params) {
  const { quoteStatusId } = params;
  const classes = useStyles();
  const { t } = useTranslation();
  const client = useApolloClient();

  const handleContactDeutsche = useCallback(() => {
    client.writeQuery({
      query: HELPBUTTON_POPOVER_OPEN_QUERY,
      data: {
        helpButton: {
          popoverOpen: true,
        },
      },
    });
  }, [client]);

  return (
    <Grid container>
      {quoteStatusId === -4 && (
        <Grid item xs={12} className={classes.contractInfoBorder}>
          <Typography>{t("Contract.PendingApproval")}</Typography>
          <Typography className={classes.reducedFont}>{t("Contract.RequestNotApprovedYet")}</Typography>
          <Typography className={classes.reducedFont}>{t("Contract.IfApprovedContractualDocuments")}</Typography>
        </Grid>
      )}
      {quoteStatusId === -12 && (
        <Grid item xs={12} className={classes.contractInfoBorder}>
          <Typography>{t("Contract.PendingApproval12")}</Typography>
          <Typography className={classes.reducedFont}>{t("Contract.RequestNotApprovedYet12")}</Typography>
        </Grid>
      )}
      {quoteStatusId === -13 && (
        <Grid item xs={12} className={classes.contractInfoBorder}>
          <Typography>{t("Contract.PendingApproval13")}</Typography>
          <Typography className={classes.reducedFont}>{t("Contract.RequestNotApprovedYet13")}</Typography>
        </Grid>
      )}
      {quoteStatusId === -8 && QuoteWithFinalStatus(true, classes, t)}
      {quoteStatusId === -9 && QuoteWithFinalStatus(false, classes, t)}
      {quoteStatusId === -5 && (
        <Grid item container xs={12} spacing={2} alignItems="center" className={classes.paddingRightLeft10}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" component="div" className={classes.fontWeightBold}>
              {t("DeclinedDocuments.Title")}
            </Typography>
            <Typography variant="caption" component="div">
              {t("DeclinedDocuments.QuoteNotApproved")}
            </Typography>
          </Grid>
          <Grid item xs={12} container className={cx(classes.confirmationItem, classes.declinedItem)}>
            <Grid item xs={1} container alignItems="center" justifyContent="center">
              <HighlightOffOutlined className={classes.fontSize35} />
            </Grid>
            <Grid item xs={11}>
              <Typography variant="subtitle2" component="div" className={classes.fontWeightBold}>
                {t("DeclinedDocuments.RequestReceivedNotApproved")}
              </Typography>
              <Typography variant="body2" component="div">
                {t("DeclinedDocuments.ContactToSeeIfAlternativeSolution")}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.gridItemPadding}>
            {CustomDivider(classes)}
          </Grid>
          <Grid item xs={12} className={classes.contractInfoBorder}>
            <Grid item xs={12} container justifyContent="center" className={classes.declinedText}>
              <Typography variant="subtitle2" component="div" className={classes.fontWeightBold}>
                {t("DeclinedDocuments.ContactForFurtherInformation")}
              </Typography>
            </Grid>
            <Grid item xs={12} container justifyContent="center" className={classes.declinedText}>
              <Button variant="contained" color="primary" onClick={handleContactDeutsche}>
                {t("Client.SearchResult.Text_4")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default ContractStatusContainer;
